'use client'

import React, { useEffect, useRef, useState } from 'react'
import { attributesToProps } from 'html-react-parser'
import { useOnScreen } from '@dustin-web/microsite-components/src/hooks'

export const OnScreenAnimation = ({
  elementName,
  onScreenAnimationName,
  classNameArray,
  delay,
  props,
  children,
}: {
  elementName: string
  onScreenAnimationName: string
  classNameArray: string[]
  delay: number
  props: ReturnType<typeof attributesToProps>
  children: React.ReactNode
}) => {
  const nodeRef = useRef<HTMLElement | null>(null)
  const aldreadyAnimated = useRef(false)
  const onScreen = useOnScreen(nodeRef)
  const [onScreenAfterDelay, setOnScreenAfterDelay] = useState(false)

  const onScreenAnimationClassName = `a-${onScreenAnimationName}-slow`

  const classNameArrayWithAnimation = [
    ...classNameArray,
    onScreenAfterDelay || aldreadyAnimated.current ? onScreenAnimationClassName : 'u-opacity-0',
  ]

  const alteredProps = {
    ...props,
    ref: nodeRef,
    className: classNameArrayWithAnimation.join(' '),
  }

  useEffect(() => {
    if (onScreen && !aldreadyAnimated.current) {
      setTimeout(() => {
        setOnScreenAfterDelay(true)
        aldreadyAnimated.current = true
      }, delay ?? 0)
    }
  }, [onScreen])

  const el = children
    ? React.createElement(elementName, { ...alteredProps }, children)
    : React.createElement(elementName, { ...alteredProps })

  return el
}
